import { FunctionComponent, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import AddressSearchInput from 'modules/AddressAutocomplete'

import Header from 'components/GlobalStyles/Header'
import Spacer from 'components/Spacer'

import { useUser } from 'services/swr/useUser'

const SignUpContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 284px;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    height: 542px;
  }
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    height: 585px;
  }
`

interface IMaxWidthProps {
  maxWidth?: number
}
const MaxWidthContainer = styled.div<IMaxWidthProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: ${props => props.maxWidth || props.theme.metrics.contentMaxWidth}px;
`

const DescriptionText = styled.div`
  font-size: 18px;
  text-align: center;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    font-size: 24px;
  }
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    font-size: 28px;
  }
`

const Br = styled.br`
  display: none;
  @media (max-width: ${props => props.theme.metrics.phone}px) {
    display: block;
  }
`

const SignUp: FunctionComponent = () => {
  const theme = useContext(ThemeContext)

  const { user } = useUser()

  return (
    <SignUpContainer>
      <MaxWidthContainer>
        <Header
          text={user ? 'Start a New Listing' : 'Get Started For Free Today'}
          fontSize={24}
          fontTabletSize={32}
          fontDesktopSize={42}
          headerThree
        />
        <Spacer
          size={20}
          responsiveSize={10}
        />
        {!user && (
          <DescriptionText>
            Enter your details to create your free listing account. <Br />
            Savings await...
          </DescriptionText>
        )}
      </MaxWidthContainer>
      <Spacer
        size={50}
        tabletSize={18}
      />
      <AddressSearchInput
        inputBackground={theme.colors.white}
        width="90vw"
        tabletWidth="720px"
        buttonWidth={250}
      />
    </SignUpContainer>
  )
}

export default SignUp
